import { Component } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
    selector: 'app-terms-of-use',
    templateUrl: './terms-of-use.component.html',
    styleUrls: ['./terms-of-use.component.scss'],
    standalone: true,
    imports: [
        TranslocoModule,
        MatTabsModule,
        MatExpansionModule,
        FlexLayoutModule
    ]
})
export class TermsOfUseComponent {
    panelOpenState = false;
    constructor() {}
}
